import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';
import { Tables } from '../lib/database.types';

const QUERY_KEY = 'skills';

export const useSkills = (options = {}) => {
  const { language = 'fr' } = options;

  return useQuery({
    queryKey: [QUERY_KEY, { language }],
    queryFn: async () => {
      const { data, error } = await supabase
        .from(Tables.SKILLS)
        .select(`
          *,
          translations:skills_translations(name, language_code)
        `)
        .order('category');

      if (error) throw error;

      return data.map(skill => ({
        ...skill,
        name: skill.translations?.find(t => t.language_code === language)?.name || skill.translations?.[0]?.name,
      }));
    },
  });
};

export const useCreateSkill = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (skill) => {
      const { data, error } = await supabase
        .from(Tables.SKILLS)
        .insert(skill)
        .select()
        .single();

      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
    },
  });
};

export default useSkills;
